module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-text",
    class: {
      'divider-text--treatments': _vm.$route.path.includes('treatment')
    }
  }, [_c('div', {
    staticClass: "divider-text__clip"
  }, [_c('parallax', {
    attrs: {
      "speedFactor": .1,
      "direction": "up",
      "sectionHeight": 400
    }
  }, [_c('div', {
    staticClass: "divider-text__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  })])], 1), _c('div', {
    staticClass: "divider-text__body"
  }, [_c('div', {
    staticClass: "divider-text__container"
  }, [_c('div', {
    staticClass: "divider-text__text",
    style: ({
      float: _vm.props.location
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ac5ea20","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/divider/divider-text/divider-text.pug
// module id = 661
// module chunks = 1